module.exports = __webpack_public_path__ + "img/szy-login-bg.ba119418.png";